import { z } from "zod";
/** Restore a soft-deleted container (carries the version it was built from). */
export const restoreContainerSchema = z.object({
    version: z.number().int().nonnegative(),
});
/** Permanently delete the given containers. */
export const purgeContainersSchema = z.object({
    ids: z.array(z.string().uuid("id must be a UUID")).min(1, "ids is required"),
});
//# sourceMappingURL=trash.js.map